import React from "react";
import * as XLSX from "xlsx";

function DownloadExcelTemplate({
  filename = "Cash_Expense_Template.xlsx",
  sheetName = "Cash_Expense",
  type,
}) {
  // console.log(">>type",type)
  // -------------------------------
  // 1. MAIN TICKET TEMPLATE
  // -------------------------------
  const headers = [
    "customerCode",
    "date",
    "expensesHead",
    "remarks",
    "paidTo",
    "type",
    "debitAmount",
    "creditAmount",
  ];

  // const sampleRow = [
  //   "CU4025",
  //   "07-08-2025",
  //   "Driver Salary",
  //   "Monthly salary for Aug",
  //   "Ravi Kumar",
  //   "Debit",
  //   "15680",
  //   "0",
  // ];
  const sampleRow = [];

  const buildWorkbook = () => {
    const data = [headers, sampleRow];
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    worksheet["!cols"] = headers.map((h) => ({
      wch: Math.min(h.length + 10, 40),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    return workbook;
  };

  const handleDownloadCashExpense = () => {
    const wb = buildWorkbook();
    XLSX.writeFile(wb, filename);
  };

  // -------------------------------
  // 2. EMPLOYEE TEMPLATE
  // -------------------------------
  const handleDownloadAlternate = () => {
    const headers = [
      "slNo",
      "companyCode",
      "customerCode",
      "bankName",
      "transactionMode",
      "bankTransactionDate",
      "partyCode",
      "remarks",
      "type",
      "debitAmount",
      "creditAmount",
    ];

    // const sample = [
    //   "EMP-001",
    //   "Ramesh Kumar",
    //   "ramesh@test.com",
    //   "IT",
    //   "2025-01-10",
    // ];

    const sample = [];

    const data = [headers, sample];
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    worksheet["!cols"] = headers.map((h) => ({ wch: h.length + 10 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bank_Template");

    XLSX.writeFile(workbook, "Bank_Template.xlsx");
  };

  // -------------------------------
  // 3. PROJECT TEMPLATE
  // -------------------------------
  const handleDownloadCustom = () => {
    const headers = [
      "Project ID",
      "Project Name",
      "Client Name",
      "Start Date (YYYY-MM-DD)",
      "End Date (YYYY-MM-DD)",
      "Project Manager",
      "Budget",
      "Status (Planned/Active/Completed)",
    ];

    const sample = [
      "PRJ-001",
      "Building Construction",
      "Srinivasa Builders",
      "2025-01-01",
      "2025-06-30",
      "Vinay",
      "2500000",
      "Active",
    ];

    const data = [headers, sample];
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    worksheet["!cols"] = headers.map((h) => ({ wch: h.length + 12 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ProjectTemplate");

    XLSX.writeFile(workbook, "project-template.xlsx");
  };

  const downloadPurchasePOUploadTemplate = () => {
    try {
      // Headers
      const headers = [
        "pONumber",
        "invoiceNr",
        "generatedDate",
        "companyCode",
        "customerCode",
        "purchaseRemarks",
        "itemNo",
        "materialCode",
        "qty",
        "grossValue",
        "dispatchDate",
        "igstRate",
      ];

      const sampleData = [
        [
          "101",
          "INV-2025-001",
          "2025-12-12",
          "SSA",
          "S0237",
          "Sample PO 1",
          "1",
          "1000001",
          "50",
          "5000",
          "2025-12-25",
          "0",
        ],
      ];

      const data = [headers, ...sampleData];

      const worksheet = XLSX.utils.aoa_to_sheet(data);

      worksheet["!cols"] = [
        { wch: 12 },
        { wch: 14 },
        { wch: 14 },
        { wch: 14 },
        { wch: 14 },
        { wch: 18 },
        { wch: 10 },
        { wch: 14 },
        { wch: 10 },
        { wch: 12 },
        { wch: 14 },
        { wch: 10 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Purchase_PO_Template"
      );

      XLSX.writeFile(workbook, "Purchase_PO_Upload_Template.xlsx");
    } catch (err) {
      console.error("Download error:", err);
    }
  };

  return (
    <div>
      {/* MAIN TEMPLATE */}
      {type === "CASHSTATMENT" && (
        <button onClick={handleDownloadCashExpense} className="btnTable">
          <i class="bi bi-download px-2"></i>
          Download 
        </button>
      )}
      {/* EMPLOYEE TEMPLATE */}
      {type === "BANKSTATMENT" && (
        <button onClick={handleDownloadAlternate} className="btnTable">
          <i class="bi bi-download px-2"></i>
          Download 
        </button>
      )}
      {/* PROJECT TEMPLATE */}
      {type === "CASHSTATMEN" && (
        <button
          onClick={handleDownloadCustom}
          className="px-4 py-2 bg-purple-600 text-white rounded-lg shadow-sm hover:bg-purple-700 transition"
        >
          <i class="bi bi-download px-2"></i>
          Download Project 
        </button>
      )}
      {/*Purchase Invoice*/}
      {type === "PURCHASEINVOICE" && (
        <button onClick={downloadPurchasePOUploadTemplate} className="btnTable">
          <i className="bi bi-download px-2"></i>
          Download 
        </button>
      )}
    </div>
  );
}

export default DownloadExcelTemplate;
